import axios from "@/plugins/axios";

let url = (data) => "/api/console/rental/subjects/${_subject}/thumb".interpolate(data);

export default {
    post({ _subject }, file) {
        var headers = { "Content-Type": "multipart/form-data" };
        var formData = new FormData();
        if (_subject) formData.append("_subject", _subject);
        formData.append("file", file);
        return axios.post(`${url({ _subject })}`, formData, { headers }).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url(data)}/${data._id}`).then((result) => result.data);
    },
};
